var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Rotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 50,
    viewBox: "0 0 103 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0273 22.2543H103V15.1345H87.0273V5.5091H59.0508V15.1345H1.25846L0 20.6959L58.7603 50H87.0273V22.2543ZM27.8797 22.2543H59.0508V37.9606L57.2115 36.9522L27.8797 22.2543Z",
    fill: "#8DBA69",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2376 16.5085H103V9.48927H87.2376V-0.000225067H59.6292V9.48927H2.59737L1.35547 14.9721L59.3426 43.8623H87.2376V16.5085ZM28.8683 16.5085H59.6292V31.9929L57.8142 30.9988L28.8683 16.5085Z",
    fill: "#4D7F2A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Rotate);
export default __webpack_public_path__ + "static/media/4_rotate.93082962.svg";
export { ForwardRef as ReactComponent };